export const Repositories = [];

export { AppRepository } from './app/app.repository';
